<template>
  <div class="container-fluid">
    <div class="row">
      <background v-if="hasBackground"
        :image-desktop="imageDesktop"
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :alt="alt"
        :background-color="backgroundColor"
        :overlay="overlay"
      />
      <div class="ct-large">
        <div :class="['row', 'justify-content-center align-items-center', getSize]">
          <div class="col">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Background from './nt-content-background.vue'

export default {
  name: 'nt-content',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    backgroundColor: {
      type: String,
      default: null
    },
    overlay: {
      type: Number,
      default: 8
    },
    imageMobile: {
      type: String
    },
    imageTablet: {
      type: String
    },
    imageDesktop: {
      type: String,
      default: null
    },
    alt: {
      type: String
    }
  },
  computed: {
    getSize() {
      return `row--${this.size}`
    },
    hasBackground() {
      return this.imageDesktop || this.backgroundColor
    }
  },
  components: {
    Background
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  & .row {
    position: relative;

    &--small {
      min-height: 500px;
    }

    &--medium {
      min-height: 500px;

      @media (min-width: 1024px) {
        min-height: 700px;
      }
    }

    &--large {
      min-height: 100vh;
    }
  }

  & .ct-large {
    & > .row {
      height: 100%;
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
}
</style>
